export { PatchesConsoleTabComponent } from './patches-console-tab.component';
